import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { CONFIGURATION } from '../app.config';

@Injectable()
export class bmpService {
    private bmpservice = CONFIGURATION.baseServiceUrl + 'bmp-full-time-report/';
    private _ssnUrl = CONFIGURATION.baseServiceUrl + 'SsnInfo/';

    constructor(private _http: Http) { }

    getReferenceData(): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(this.bmpservice + 'reference-data', { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    getReportData(data:any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.post(this.bmpservice + 'report-data', data, { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }

    downloadExcelReport(filterCriteria: any): any {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.post(this.bmpservice + 'excel-download', filterCriteria, { headers: headers, responseType: ResponseContentType.Blob }).map(
            (res) => {
                const a = document.createElement('a');
                document.body.appendChild(a);
                const blob = new Blob([res.blob()], { type: 'application/zip' });
                const downloadUrl = URL.createObjectURL(blob);
                window.open(downloadUrl);
            })
    }
    private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error(error);
        return Observable.throw(error.json().error || 'Failed in web api(Server error) ');
    }

}



// WEBPACK FOOTER //
// ./src/app/bmp/bmp.service.ts